import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusHistoryChainModel, StatusHistoryOriginEnum } from '../../common/models';
import { LOCALE_DEFAULT_FORMAT, StatusHistoryConditionType, IconNames, SCode } from '../../common/constants';

@Component({
  selector: 'ui-status-history-chain',
  templateUrl: './status-history-chain.component.html',
  styleUrls: ['./status-history-chain.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusHistoryChainComponent {
  @Input() historyStatuses: StatusHistoryChainModel[] = [];
  @Input() hasPredictedDateTime = false;

  statusHistoryOrigin = StatusHistoryOriginEnum;
  dateFormat = LOCALE_DEFAULT_FORMAT;
  iconNames = IconNames;
  statusCodes = SCode;
  betaFlag = 'beta';
  conditionClassMap = {
    [StatusHistoryConditionType.Actual]: 'actual',
    [StatusHistoryConditionType.NotProvided]: 'not-provided',
    [StatusHistoryConditionType.Estimated]: 'estimated',
    [StatusHistoryConditionType.NotExpected]: 'not-expected',
  };
}
